import { useEffect, useState } from "react";
import { URL_API } from "../../utils/helper/helpers";
import axios from "axios";
import { toast } from "react-toastify";
import { Row, Col, Card, CardHeader } from "reactstrap";
import { H4, H6 } from "../../AbstractElements";
import { formatPrice } from "../../utils/helper/helpers";


interface CarburantsInterface {
    [key: string]: any;
}

const useCarburantsListe = (refresh: boolean): CarburantsInterface[] => {
    const [carburants, setCarburants] = useState<CarburantsInterface[]>([]);
    const Token = JSON.parse(localStorage.getItem("login")!);

    useEffect(() => {
        const fetchCarburants = async () => {
            axios.get(`${URL_API}/carburant/index`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.status === 200) {
                    setCarburants(response.data.carburant);
                }

            }).catch(error => {

                if (error.response.status === 404) {
                    toast.info(error.response.data.message);
                }
            })
        };

        fetchCarburants();
    }, [refresh]);
    return carburants;
};
export default useCarburantsListe;

export const deleteCarburant = async ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/carburant/destroy/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.warning("Élément Supprimer avec succès")
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 404) {
            toast.info(error.response.data.message)
        }
        if (error.response.status === 500) {
            toast.info(error.response.data.message)
        }
    })

}

export const changeStatus = ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/carburant/stau/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.success("Status Changé avec success")
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 405) {
            toast.info(error.response.data.message)
        }
    })
}

export const singlePayed = ({ value }: { value: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/payed-carburant/single`, { value }, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.success("Status Changé avec success")
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 405) {
            toast.info(error.response.data.message)
        }
    })
}

export const monthPayed = ({ value }: { value: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    axios.post(`${URL_API}/payed-carburant/month`, { value }, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {
        if (response.data.success) {
            toast.success(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 400) {
            toast.info(error.response.data.message)
        }
    })
}

export const intervalePayed = ({ startDate, endDate }: { startDate: string, endDate: string }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    axios.post(`${URL_API}/payed-carburant/intervale`, { startDate, endDate }, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.success(response.data.message)
            onSuccess();
        }

    }).catch(error => {

        if (error.response.status === 405) {
            toast.info(error.response.data.message)
        }
    })
}


export const cardCarburant = ({ value }: { value: { [key: string]: any } }) => {
    let total_bon = 0;
    let quantite_litre = 0;
    let total_montant = 0;

    // Utilisation de `reduce` pour améliorer la lisibilité et l'efficacité
    value.forEach((item: any) => {
        total_bon += 1;
        quantite_litre += Number(item.quantite_litre);
        total_montant += Number(item.montant);

        // Si c'est une entrée
        // if (item.type === 'Entrée') {
        //     entre += 1;
        //     entre_solde += item.montant;  // Accumule les montants des entrées
        //     total_montant += item.montant;  // Ajoute au total général
        // }

        // // Si c'est une sortie
        // else if (item.type === 'Sortie') {
        //     sortie += 1;
        //     sortie_solde += item.montant;  // Accumule les montants des sorties
        //     total_montant -= item.montant;  // Soustrait du total général
        // }
    });
    return (
        <Row>
            <Col sm="4">
                <Card className="progress-items pb-0 bg-light-info">
                    <CardHeader className="pb-4 bg-light-info">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">{total_bon.toLocaleString("gn-GN")}</span>
                                </H4>
                                <H6 className="f-20 f-w-600 mt-3">
                                    Bon de Carburant
                                </H6>
                            </div>
                            <div>
                                <i className="icofont icofont-growth f-80"></i>

                                {/* {

                                    total_montant >= 0 ? (
                                        <i className="icon-stats-up f-80"></i>
                                    ) : (
                                        <i className="icon-stats-down f-80 text-danger"></i>
                                    )
                                } */}
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>
            <Col md="4">
                <Card className="progress-items pb-0 bg-light-success">
                    <CardHeader className="pb-4 bg-light-success">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">{quantite_litre.toLocaleString("gn-GN")} Littres</span>
                                </H4>
                                <H6 className="f-20 f-w-600 mt-3">
                                    Quantite Total
                                </H6>
                            </div>
                            <div>
                                <i className="icofont icofont-filter f-80"></i>
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>
            <Col md="4">
                <Card className="progress-items pb-0 bg-light-info">
                    <CardHeader className="pb-4 bg-light-info">
                        <div className="d-flex justify-content-between">
                            <div>
                                <H4>
                                    <span className="text-dark fw-bold">{formatPrice(total_montant)}</span>
                                </H4>
                                <H6 className="f-20 f-w-600 mt-3 text-white">
                                    Montant Total
                                </H6>
                            </div>
                            <div>
                                <i className="icofont icofont-money-bag f-80"></i>
                            </div>
                        </div>
                    </CardHeader>
                </Card>
            </Col>

        </Row>
    )
};